import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function ragReportReorder(requestor) {
  return createReduxPromiseAction(
    ActionTypes.RAG_REPORT_REORDER,
    (
      organisationId,
      projectId,
      documentId,
      documentIssueId,
      additionalItemId,
      reportId,
      oldPosition,
      newPosition,
      issuesetId,
    ) =>
      requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/reorder`,
          {
            oldPosition,
            newPosition,
            reportId,
            issuesetId,
            documentIssueId,
            additionalItemId,
          },
          {withCredentials: true},
        )
        .then(response => response.data),
  );
}
